import { CircleCheck, CircleOff } from 'lucide-react';
import { c } from '../../styles/theme';

export interface PublicationStatusProps {
  published?: boolean;
}

export default function PublicationStatus({ published = true }: PublicationStatusProps) {
  const label = published ? 'Published' : 'Unpublished';
  const color = published ? c.success : c.danger;
  const Icon = published ? CircleCheck : CircleOff;

  return (
    <span
      role="status"
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        color,
        whiteSpace: 'nowrap',
      }}
      title={label}
    >
      <Icon size={13} strokeWidth={2.2} aria-hidden="true" />
    </span>
  );
}
